export default {
  setBalance(state: any, balance: any) {
    state.balance = balance || {}
  },
  setEvent(state: any, event: any) {
    state.event = event || null
  },
  setEnded(state: any, ended: boolean) {
    state.ended = ended
  },
  setBonuses(state: any, {results, count}: any) {
    state.bonuses = results || []
    state.bonusesCount = count || 0
  },
  setAvailableBonuses(state: any, bonuses: any) {
    state.availableBonuses = bonuses || []
  },
}
